import dataProviderMapper from "../providers/DataProviderMapper";
export const mapping = {
  'rootDataProvider': dataProviderMapper
}

export const components_mapping = {
  // 'CustomTextField': CustomTextField
}